import type { ChangeEvent } from 'react'
import React, { useEffect, useRef, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { TextInput, csx } from '@vtex/admin-ui'

import { DrawerBody, DrawerFooter } from '../../../../../../ui/components'
import { CheckoutButton } from '../../../../components'

export type ShareCartInfoContentProps = {
  onGenerateLinkClick: (additionalInfo: string) => void
}

export const ShareCartInfoContent = ({
  onGenerateLinkClick,
}: ShareCartInfoContentProps) => {
  const { formatMessage } = useIntl()
  const [additionalInfo, setAdditionalInfo] = useState('')
  const additionalInfoRef = useRef<HTMLInputElement>(null)

  const handleAdditionalInfoChange = (event: ChangeEvent<HTMLInputElement>) => {
    setAdditionalInfo(event.target.value)
  }

  const handleFormSubmit = (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault()

    onGenerateLinkClick(additionalInfo)
  }

  useEffect(() => {
    additionalInfoRef.current?.focus()
  }, [])

  return (
    <form className={csx({ display: 'contents' })} onSubmit={handleFormSubmit}>
      <DrawerBody>
        <p className={csx({ fontSize: '0.875rem', marginTop: '$space-3' })}>
          <FormattedMessage id="checkout.options-drawer.share.message" />
        </p>
        <span
          className={csx({
            marginTop: '$space-3',
            marginBottom: '$space-3',
            fontSize: '0.875rem',
            display: 'block',
          })}
        >
          <FormattedMessage id="checkout.options-drawer.share.additional-information" />
        </span>
        <TextInput
          ref={additionalInfoRef}
          value={additionalInfo}
          onChange={handleAdditionalInfoChange}
          onBlur={handleAdditionalInfoChange}
          aria-label={formatMessage({
            id: 'checkout.options-drawer.share.additional-information',
          })}
          placeholder={formatMessage({
            id: 'checkout.options-drawer.share.input-placeholder',
          })}
        />
      </DrawerBody>
      <DrawerFooter>
        <CheckoutButton
          type="submit"
          size="large"
          className={csx({ width: '100%' })}
        >
          <FormattedMessage id="checkout.options-drawer.share.submit-button" />
        </CheckoutButton>
      </DrawerFooter>
    </form>
  )
}
